import { useState, useEffect } from "react";
import { Thumbnail_View } from "./ThumbnailView";
import { LoadingComponent, Loader } from "./LoadingComponent";
import { SidebarDetailedView } from "./SideDetailedView";
import "../assets/styles/collections_contents.css"
import { get_tag_list_of_mapped_videos, remove_tags_from_video, download_files } from "../assets/constants/global_apis";
import { AlertMessageBox } from "./AlertMessage";



const labelContainerheight = window.screen.availHeight < 800 ? (window.screen.availHeight * 0.51) : (window.screen.availHeight * 0.73)


export const TagsContentsView = ({  selectedtagId,isSidebarOpen, setIsSidebarOpen  }) => {
    const [contents, setContents] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [checkedState, setCheckedState] = useState([]);
    const [checkAll, setCheckAll] = useState(false);
    const [buttonAction, setbuttonAction] = useState({
        label: {},
        event: '',
        eventMessage: ''
    })

    const [collectionLabelSet, setCollectionLabelSet] = useState([])
    const [open, setOpen] = useState(false);
    const [showAlertBox, setShowAlertBox] = useState(false);
    const [alertMessage, setAlertMessage] = useState({
        Errortype: "Error",
        title: "",
        message: "",
    });
    const openAlertPopup = (errorType, title, message) => {
        setAlertMessage({
            Errortype: errorType,
            title: title,
            message: message,
        });
        setShowAlertBox(true);
        setTimeout(function () {
            setShowAlertBox(false);
        }, 2000);
    };


    const get_tags_contents = () => {
        setIsLoading(true);
        setContents([]);
        setCheckAll(false);
        get_tag_list_of_mapped_videos(selectedtagId).then(data => {
            setContents(data);
            setCheckedState(data.map(() => false));
            setIsLoading(false);
        })
            .catch(error => {
                setContents([]);
                setIsLoading(false);
            });
    }


    const handleChange = (index, isChecked) => {
        const updatedCheckedState = checkedState.map((item, idx) =>
            idx === index ? isChecked : item
        );
        setCheckedState(updatedCheckedState);

        // Update checkAll state if all individual checkboxes are checked/unchecked
        const allChecked = updatedCheckedState.every(item => item === true);
        const noneChecked = updatedCheckedState.every(item => item === false);
        setCheckAll(allChecked);
    };
    const getSelectedValues = () => {
        return contents
            .filter((_, index) => checkedState[index])
            .map(content => content.path);
    };
    const removeItemsFromTags = () => {
        const selected_files = getSelectedValues();
        let fltContents = contents.filter((content) => selected_files.includes(content.path))
        const filteredContents = (fltContents).map((item) => {
            return {
                "path": item.path,
                "backendId": item.backendId
            }
        });
        remove_tags_from_video(selectedtagId, filteredContents).then((response) => {
            get_tags_contents();
        })

    }

    const handleSelectAll = (e) => {
        setCheckAll(e.target.checked);
        const newCheckState = contents.map(() => e.target.checked);
        setCheckedState(newCheckState);
    }

    useEffect(() => {
        get_tags_contents();
        // get_collections_labelList();
    }, [selectedtagId])

    const handleLabelSetUnavailability = () => {
        openAlertPopup("Error", "LabelSet Not Found", "Please Add the Labelset before doing annotation!!!");
    }

    return (
        <>
            <div className="collectionContentContainer d-flex p-2 border-bottom justify-content-start align-items-center">
                <div className="">
                    <div className="input-group-text">
                        <input id="selectAll" className="form-check-input mt-0 me-2" checked={checkAll} type="checkbox" onChange={(e) => handleSelectAll(e)} />
                        <label htmlFor="selectAll" className="form-check-label">
                            {
                                checkAll ? "Unselect all" : "Select all"
                            }
                        </label>
                    </div>
                </div>

                {
                    checkedState.some((item) => item) &&
                    <>
                        <button className="btn btn-danger ms-2" onClick={() => removeItemsFromTags()}>
                            Remove from Tags
                        </button>
                    </>
                }
                {
                    checkedState.some((item) => item) &&
                    <button className="btn btn-dark" style={{ marginLeft: '1%' }} onClick={() => download_files(contents.filter((_, index) => checkedState[index]))}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 me-2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                        </svg>
                        Download file
                    </button>
                }

            </div>
            <div className="position-relative" style={{ height: "calc(100vh - 115px)", overflow: "auto" }}>
                <div className="container-fluid g-2 mt-2">
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-6 g-2">
                        {
                            contents.length > 0 &&
                            contents.map((content, index) => (
                                <div className="col mt-2" key={index} title={content.id}>
                                    <div className={`form-check position-relative cursor-pointer ${checkedState[index] ? "checked" : "" }`}>
                                        {/* <input
                                            className="form-check-input file-checkbox"
                                            type="checkbox"
                                            value={content.label}
                                            onChange={(e) => handleChange(index, e.target.checked)}
                                            id={"fileCheck-" + selectedtagId + "-" + index}
                                            name={'collectionId-' + selectedtagId}
                                            checked={checkedState[index]}
                                        /> */}

                                        <label className="form-check-label d-flex flex-column" htmlFor={"fileCheck-" + selectedtagId + "-" + index}>
                                            <Thumbnail_View path={{ content, index, selectedtagId, collectionLabelSet, handleLabelSetUnavailability, isAnnotationNotAvailable: true ,handleFileSelect:handleChange,checkedState:checkedState}} setIsSidebarOpen={setIsSidebarOpen} isSidebarOpen={isSidebarOpen} />
                                        </label>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
                {
                    contents.length === 0 &&
                    <div className="d-flex justify-content-center align-items-center h-100">
                        <span>No data available</span>
                    </div>
                }
                {isLoading && <LoadingComponent />}
            </div>
            <SidebarDetailedView isitTagView={true} isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
            <div className='annotationLabelSetAlertcontainer'>
                <AlertMessageBox
                    showAlertBox={showAlertBox}
                    setShowAlertBox={setShowAlertBox}
                    alertMessage={alertMessage}
                />
            </div>
        </>
    )

}